import { AppState } from "store/rootReducer";
import { createSelector } from "reselect";

const filtersState = (state: AppState) => state.filters;

export const getFiltersFields = createSelector(filtersState, ({ fields }) => fields);
